import React from "react";
import { Card } from "antd";
import type { CSSProperties, MutableRefObject, ReactNode } from "react";

import { Table } from "@components/Table";
import type { Operation } from "@api";

import "./List.css";

const CARD_CLASS_NAME = "card-mobile";
const TABLE_CLASS_NAME = "list-mobile";

const ID_COLUMN_KEY = "id";

const FULL_WIDTH_STYLE: CSSProperties = { width: "100%" };

const CARD_STYLES = { body: { padding: 0, paddingTop: 1 } };

const BANNER_STYLE: CSSProperties = {
  padding: "8px 12px",
  width: "100%",
  boxShadow: "none",
  borderBottom: "1px solid #f0f0f0",
};

const CONTENT_STYLE: CSSProperties = {
  padding: 0,
  width: "100%",
  boxShadow: "none",
};

type Item = Record<string, unknown>;

type Props = {
  title: string;
  table?: MutableRefObject<unknown>;
  banner?: ReactNode;
  render: (value: unknown, item: Item) => ReactNode;
  onClick?: (item: Item) => void;
  indexOperation: Operation;
  [key: string]: unknown;
};

const List = ({
  table,
  banner,
  onClick,
  title,
  render,
  indexOperation,
  ...otherTableProps
}: Props): JSX.Element => {
  const columnsConfig = [
    {
      key: ID_COLUMN_KEY,
      render,
    },
  ];

  const onRow = (item: Item) => ({
    onClick: () => {
      const hasClickHandler = !!onClick;

      if (!hasClickHandler) {
        return;
      }

      onClick(item);
    },
  });

  const tableProps = {
    bordered: false,
    className: TABLE_CLASS_NAME,
    showHeader: false,
    shouldRenderHeader: false,
    onRow,
    style: FULL_WIDTH_STYLE,
    table,
    columnsConfig,
    indexOperation,
    ...otherTableProps,
  };

  const hasBanner = !!banner;

  return (
    <Card
      type="inner"
      size="small"
      title={title}
      styles={CARD_STYLES}
      bordered={false}
      className={CARD_CLASS_NAME}
    >
      {
        hasBanner && (
          <Card.Grid
            style={BANNER_STYLE}
            hoverable={false}
          >
            {banner}
          </Card.Grid>
        )
      }
      <Card.Grid
        style={CONTENT_STYLE}
        hoverable={false}
      >
        <Table {...tableProps} />
      </Card.Grid>
    </Card>
  );
};

export default List;
